import * as React from 'react';
import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { useSelector } from 'react-redux';
import { checkFsk } from '../../selectors';
import { useApplicationContext } from '../../utils';
import { GenericError } from '@cian/peperrors/shared';
import { selectPuids } from '../../selectors/adfox';
const Adfox = connect(AdFoxTemplates);

export const AdfoxPixelContainer: React.FC = () => {
  const { logger, custom } = useApplicationContext();
  const isFsk = useSelector(checkFsk);
  const puids = useSelector(selectPuids);

  if (!(isFsk || custom.isPageTemplateSpecialPromo) || !puids) {
    return null;
  }

  const onStubHandle = () => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: 'adfoxStub',
        details: { developerId: puids.puid39 },
      }),
    );
  };

  const onErrorHandle = (event: { type: string }) => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: event.type,
        details: { developerId: puids.puid39 },
      }),
    );
  };

  return (
    <Adfox
      onError={onErrorHandle}
      onStub={onStubHandle}
      params={{ p1: 'cyrbe', p2: 'frfe', ...puids }}
      width="1"
      height="1"
    />
  );
};
